<template>
    <div id="buy-back">
        <div class="top-part">
            <img class="top-back" src="@/assets/buy-back/top-back.png" alt="">
            <div class="number-box">
                <img src="@/assets/buy-back/gzt.png" alt="">
                <span class="line"></span>
                <span class="number">第01期</span>
            </div>
            <div class="big-title">
                <img class="title-img" src="@/assets/buy-back/big-title.png" alt="">
                <div v-show="dateCountdown > 0" class="countdown">
                    <img src="@/assets/buy-back/countdown.png" alt="">
                    <span>{{dateCountdown}}</span>
                </div>
            </div>
        </div>
        <div class="operate-part-wrapper" :class="isApply ? 'apply' : ''">
            <div class="operate-part">
                <div class="operate-title">回购情况
                    <img src="@/assets/buy-back/operate-title-back.png" alt="">
                </div>
                <div class="progress-wrapper">
                    <span class="back">已回购：{{maxValue - tokenBalance}} GZT</span>
                    <span class="remain">剩余：{{tokenBalance}} GZT</span>
                    <div class="progress-bar">
                        <div class="progress-value" :style="{'width': ((maxValue - tokenBalance) / maxValue * 100 ) + '%'}"></div>
                    </div>
                </div>
                <div class="info-box" v-show="!isApply">
                    <div class="clearfix">
                        <span class="left">本期回购数量：</span>
                        <span class="right">{{maxValue}} GZT</span>
                    </div>
                    <div class="clearfix">
                        <span class="left">回购价格：</span>
                        <span class="right">{{rateShow}}</span>
                    </div>
                    <div class="clearfix">
                        <span class="left">回购时间：</span>
                        <span class="right">{{startTime | parseTime('{m}月{d}日')}} - {{endTime | parseTime('{m}月{d}日')}}</span>
                    </div>
                </div>
                <div class="sub-btn" :class="dateCountdown > 0 || isOutOfDate ? '' : 'active'" v-show="!isApply" @click="joinBack">{{dateCountdown > 0 ? '活动未开始': (isOutOfDate ? '活动已结束' : '我要参与')}}</div>
            </div>
            <div class="apply-part" v-show="isApply">
                <div class="operate-title">参与回购
                    <img src="@/assets/buy-back/operate-title-back.png" alt="">
                </div>
                <div class="my-count">我的GZT：{{myTokenCount}}</div>
                <div class="input-box">
                    <input v-model="inputCount" type="number" placeholder="请输入您的申请数量">
                    <span class="unit">GZT</span>
                </div>
                <div class="tip-box">
                    <span v-show="inputCount" class="count">回购可得金额 ≈ {{(inputCount * rate).toFixed(4)}}USDT</span>
                </div>
                <div class="sub-btn" @click="submit">申请参与</div>
            </div>
        </div>
        <div class="rule-part">
            <div class="operate-title">活动规则
                <img src="@/assets/buy-back/rule-title-back.png" alt="">
            </div>
            <div class="rules">
                <p>1.回购数量有限，先到先得。本期每人最多可申请参与回购 50000GZT。</p>
                <p>2.申请成功后，回购所得USDT将发放至用户账户中。请前往“我的Token”查看。</p>
                <p>3.本活动最终解释权归金果子所有，如有疑问请咨询金果子官方客服。(微信号:jgzcom)</p>
            </div>
        </div>
        <div id="mask" v-show="maskViewShow" >
            <div class="dialog">
                <div class="dialog-content">
                    <span>申请成功！<strong>{{(inputCount * rate).toFixed(4)}}个USDT</strong></span><br/>
                    <span>已发放到您的账户，请注意查收。</span>
                </div>
                <div class="dialog-footer" @click="maskViewShow = false; inputCount = ''">好的</div>
            </div>
        </div>
        <jgz-loading :loading-show='showLoading'></jgz-loading>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>

<script>
// const Base64 = require('js-base64').Base64
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'BuyBack',
    data() {
        return {
            token: null,
            userId: null,
            startTime: null,
            endTime : null,
            dateCountdown: null,
            isOutOfDate: true,
            timer: null,
            isApply: false,
            maskViewShow: false,
            alertShow: false,
            message: '',
            inputCount: null,
            myTokenCount: null,
            rate: null,
            maxValue: null,
            tokenBalance: null,
            rateShow: null,
            coinToken: null,
            showLoading: false,
        }
    },
    components: {
        JgzLoading,
    },
    mounted() {
        const params = this.$route.query
        this.token = params.auth
        this.userId = params.userId
        this.getBuyBackInfo()
        this.getTokenBanlance()
        this.timer = setInterval(()=>{
            this.dateCountdown = Math.ceil((this.startTime - new Date()) / (24 * 3600 * 1000))
        }, 1000)
    },
    methods: {
        joinBack() {
            if(this.dateCountdown > 0 || this.isOutOfDate) {
                return
            }
            if(!(this.userId && this.token)) {
                this.showAlert('活动需要先登录')
                this.$setupWebViewJavascriptBridge(function(bridge) {
                    bridge.callHandler('handleOpenLoginPage', {data: 'buy-back'});
                });  
                if (window.androidHandler) {  
                    let str = JSON.stringify({params: 'OpenLoginPage', data: 'buy-back'});
                    androidHandler.setValue(str);
                }
                return
            }else{
                this.getMyToken()
                this.isApply = true
            }
        },
        //  获取活动信息
        getBuyBackInfo() {
            this.$MyAxios.get(`/api/activities/buyBack/info`, 
            {}, 
            response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.rate = response.data.rate
                    this.maxValue = response.data.maxValue
                    this.rateShow = response.data.rateShow
                    this.startTime = response.data.start
                    this.endTime = response.data.end
                    this.coinToken = response.data.token
                    this.isOutOfDate = this.endTime - new Date() <= 0
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
            })
        },

        //  查询余额
        getTokenBanlance() {
            this.$MyAxios.init({ token: this.token })
            this.$MyAxios.get(`/api/activities/buyBack/stock`, 
            {
                params: { token: 'GZT' }
            }, 
            response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.tokenBalance = response.data
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
            })
        },

        //  查询我的token
        getMyToken() {
            this.$MyAxios.init({ token: this.token })
            this.$MyAxios.get(`/api/user/tokens/tokenBalance`, 
            {
                params: { userId: this.userId, username: this.userId, token: 'GZT' }
            }, 
            response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.myTokenCount = response.data
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
            })
        },

        //  提交
        submit() {
            // this.maskViewShow = true
            if(this.dateCountdown > 0) {
                this.showAlert("活动暂未开始")
                return
            }
            if(typeof(parseInt(this.inputCount)) !== "number" || parseInt(this.inputCount) <= 0 || this.inputCount % 1 !== 0 || !this.inputCount){
                this.showAlert("请输入整数且大于0")
                return
            }
            if(parseInt(this.inputCount) > this.tokenBalance){
                this.showAlert("数量不能大于活动余额")
                return
            }
            this.showLoading = true
            this.$MyAxios.post('/api/user/activities/buyBack', 
            {
                userId: this.userId,
                username: this.userId, 
                count: this.inputCount,
                token: 'GZT'
            },
            false,
            response => {
                if(response.code === 1) {
                    // this.showAlert("申请成功，请等待审核！")
                    this.maskViewShow = true
                    this.showLoading = false
                    this.getBuyBackInfo()
                    this.getTokenBanlance()
                    this.getMyToken()
                }
            },
            error => {
                this.showAlert(error)
                this.showLoading = false
            })
        },

        showAlert(message) {
            return new Promise((resolve, reject) => {
                this.message = message;
                this.alertShow = true;
                setTimeout(() => {
                    this.alertShow = false;
                    resolve()
                }, 1500);
            })
        },
    },
    destroyed() {
        this.timer = undefined
    }
}
</script>

<style lang="less">
#buy-back {
    background: #FFA41F;
    min-height: 100vh;
    .top-part {
        height: 732px;
        width: 100vw;
        .top-back {
            height: 732px;
            width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
        }
        .number-box {
            z-index: 20;
            height: 62px;
            border-radius: 0 0 40px 40px;
            background: #FFA41F;
            width: 40vw;
            margin: 0 auto;
            position: relative;
            text-align: center;
            line-height: 62px;
            margin-bottom: 10px;
            img {
                width: 97px;
                height: 37px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                color: #ffffff;
            }
            .line {
                height: 36px;
                width: 1px;
                background: #FFB64C;
                margin: 0 10px;
            }
            .number {
                font-size: 30px;
            }
        }
        .big-title {
            height: 214px;
            width: 685px;
            position: relative;
            margin: 0 32px;
            .title-img {
                height: 214px;
                width: 685px;
                left: 0;
                top: 0;
                position: absolute;
            }
            .countdown {
                height: 131px;
                width: 598px;
                left: 43px;
                bottom: -110px;
                position: absolute;
                img {
                    height: 131px;
                    width: 598px;
                    left: 0;
                    top: 0;
                    position: absolute;
                }
                span {
                    position: absolute;
                    display: inline-block;
                    width: 76px;
                    text-align: center;
                    right: 114px;
                    top: 30px;
                    font-size: 68px;
                    font-weight: bold;
                    color: #ffffff;
                }
            }
        }
    }
    .operate-part-wrapper {
        position: relative;
        width: 690px;
        margin: 0 auto;
        height: 370px;
        &.apply {
            height: 510px;
            .operate-part {
                height: 230px;
            }
        }
    }
    .operate-part {
        height: 590px;
        width: 690px;
        border-radius: 20px;
        background: #ffffff;
        z-index: 30;
        top: -220px;
        left: 0;
        position: absolute;
        padding: 30px 45px;
        .operate-title {
            line-height: 48px;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
            img {
                position: absolute;
                left: 50%;
                top: 40px;
                transform: translatex(-50%);
                height: 25px;
                width: 217px;
            }
        }
        .progress-wrapper {
            height: 80px;
            width: 100%;
            padding-top: 50px;
            position: relative;
            margin-bottom: 40px;
            span {
                position: absolute;
                font-size: 28px;
                line-height: 34px;
                font-weight: bold;
                top: 0;
                &.back {
                    left: 0;
                    color: #9598A6;
                }
                &.remain {
                    right: 0;
                }
            }
            .progress-bar {
                width: 100%;
                height: 30px;
                background: #ebecf0;
                border-radius: 15px;
                position: relative;
            }
            .progress-value {
                width: 30%;
                height: 30px;
                background: linear-gradient(left, #ffa41f, #ff551f);
                border-radius: 15px;
            }
        }
        .info-box .clearfix{
            margin-bottom: 30px;
            font-size: 28px;
            line-height: 34px;
            color: #33333a;
        }
        .sub-btn {
            margin-top: 40px;
            width: 600px;
            height: 88px;
            background: #FFD18E;
            border-radius: 44px;
            cursor: pointer;
            line-height: 88px;
            color: #ffffff;
            font-weight: bold;
            font-size: 32px;
            &.active {
                background: #FFA41F;
            }
        }
    }
    .apply-part {
        height: 480px;
        width: 690px;
        border-radius: 20px;
        background: #ffffff;
        z-index: 30;
        bottom: 0px;
        left: 0;
        position: absolute;
        padding: 30px 45px;
        .operate-title {
            line-height: 48px;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
            img {
                position: absolute;
                left: 50%;
                top: 40px;
                transform: translatex(-50%);
                height: 25px;
                width: 217px;
            }
        }
        .my-count {
            font-size: 28px;
            color: #33333A;
            font-weight: bold;
            text-align: left;
            line-height: 34px;
            margin-bottom: 15px;
        }
        .input-box {
            border: 1px solid #ebecf0;
            height: 88px;
            border-radius: 8px;
            text-align: left;
            margin-bottom: 15px;
            overflow: hidden;
            input {
                height: 86px;
                width: 500px;
                font-size: 32px;
                outline:none;
                color: #33333A;
                font-weight: bold;
                border: none;
                text-indent: 20px;
            }
            .unit {
                font-size: 28px;
                display: inline-block;
                color: #33333A;
                line-height: 40px;
                font-weight: bold;
            }
        }
        .tip-box {
            font-size: 24px;
            text-align: left;
            margin-bottom: 60px;
            .count {
                margin-right: 20px;
            }
        }
        .sub-btn {
            margin-top: 40px;
            width: 600px;
            height: 88px;
            background: #FFA41F;
            border-radius: 44px;
            cursor: pointer;
            line-height: 88px;
            color: #ffffff;
            font-weight: bold;
            font-size: 32px;
        }
    }
    .rule-part {
        position: relative;
        padding: 40px 60px;
        .operate-title {
            line-height: 48px;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
            img {
                position: absolute;
                left: 50%;
                top: 50px;
                transform: translatex(-50%);
                height: 25px;
                width: 217px;
            }
        }
        .rules {
            text-align: left;
            line-height: 48px;
            font-size: 28px;
            color: #33333A;
        }
    }
    .dialog {
        width: 560px;
        height: 290px;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-280px, -145px);
        .dialog-content {
            line-height: 50px;
            font-size: 34px;
            color: #33333A;
            font-weight: bold;
            padding: 50px 0;
            height: 200px;
            border-bottom: 1px solid #EBECF0;
            strong {
                color: #ffa41f;
            }
        }
        .dialog-footer {
            line-height: 90px;
            color: #ffa41f;
            font-size: 34px;
            font-weight: bold;
        }
    }
    .alert {
        position: fixed;
        font-size: 24px;
        z-index: 666;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-50%);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>
